export default "__VITE_ASSET__BjJb3wro__"